<template>
  <div class="default-modal">
    <el-dialog
      v-model="visibleInternal"
      width="35%"
      class="vue-modal"
      :before-close="onClose"
    >
      <div class="dialog-header">
        <span class="header-part">SENDOUT REMOVE</span>
        <el-button size="medium" class="el-white" type="info" plain @click="onClose">
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
        </el-button>
      </div>
      <div class="popup-date">
        <p class="confirm-text">Sendout will be removed and the case will proceed for finalization.</p>
      </div>
      <div class="dialog-footer mt-5 mr-20">
        <el-button class="blue-save-button" @click="onYes">OK</el-button>
      </div>
    </el-dialog>
  </div>
  
</template>

<script>
export default {
  name: "SendoutRemovePopup",
  props: {
    modelValue: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  data() {
    return {
      visibleInternal: this.modelValue,
    };
  },
  watch: {
    modelValue(val) {
      this.visibleInternal = val;
    },
    visibleInternal(val) {
      this.$emit("update:modelValue", val);
    },
  },
  methods: {
    onClose() {
      this.$emit("cancel");
      this.visibleInternal = false;
    },
    onYes() {
      this.$emit("confirm", true);
      this.visibleInternal = false;
    },
  },
};
</script>

<style scoped>
.confirm-text {
  font-size: 14px;
  color: #333333;
  margin: 10px 0 0 0;
}
</style>


